import Phaser from "phaser";
import { useEffect, useRef } from "react";

import Game from "./scenes/Game";
import VisualEffect from "./scenes/VisualEffect";
import Settings from "./components/settings";
import styled from "styled-components";
import { motion } from "framer-motion";

function App() {
  const GameView = useRef(null);
  // const [useDebug, setDebug] = useState(false);
  // mobileDebug();
  //START
  useEffect(() => {
    var gameConfig = {
      type: Phaser.CANVAS,
      canvas: GameView.current,
      customEnvironment: true,
      transparent: true,

      // fps: {
      //   forceSetTimeOut: true,
      // },

      scale: {
        // mode: Phaser.Scale.FIT,
        // autoCenter: Phaser.Scale.CENTER_BOTH,
        // width: Settings.WIDTH,
        // height: Settings.HEIGHT,
        parent: "GameView",
      },

      backgroundColor: "#2d2d2d",
      parent: "GameView",
      dom: {
        createContainer: true,
      },

      // scene: [Game],

      // callbacks: {
      //   postBoot: function (game) {
      //     game.domContainer.style.pointerEvents = "none";
      //   },
      // },
    };

    var vfxConfig = {
      type: Phaser.AUTO,
      width: Settings.WIDTH,
      height: Settings.HEIGHT,
      transparent: true,

      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        parent: "GameView",
      },

      backgroundColor: "rgba(120,120,120,0)",
      parent: "GameView",
      // scene: [VisualEffect],
    };

    // Create Game Scene
    let GameRoot = new Phaser.Game(gameConfig);
    let GameScene = new Game();
    // //Create VFX Scene
    // let VFXRoot = new Phaser.Game(vfxConfig);
    // let VFXScene = new VisualEffect();

    // const handleGameReady = () => {
    //   //Insert GameRoot to VFXRoot
    //   VFXScene.gameScene = GameRoot.scene.getScene("Game");
    //   console.log("Game run successfully...");
    //   VFXScene.onReady();
    // };

    // const handleVFXReady = () => {
    //   console.log("VFX run successfully...");
    //   //Insert VFXRoot To GameRoot
    //   GameScene.vfxScene = VFXRoot.scene.getScene("VisualEffect");
    // };

    // GameScene.onReady = handleGameReady;
    GameRoot.scene.add("Game", GameScene, true);

    // VFXScene.onReady = handleVFXReady;
    // VFXRoot.scene.add("VisualEffect", VFXScene, true);
  }, []);

  return (
    <Container>
      <div id={"GameView"}></div>
      {/* {useDebug && <Debug id={"debugDiv"} />} */}
    </Container>
  );
}

// eslint-disable-next-line
const mobileDebug = () => {
  if (typeof console != "undefined")
    if (typeof console.log != "undefined")
      // @ts-ignore
      console.olog = console.log;
    // @ts-ignore
    else console.olog = function () {};

  console.log = function (message) {
    // @ts-ignore
    console.olog(message);
    const DebugDiv = document.getElementById("debugDiv");
    DebugDiv.append("\n" + message);
    DebugDiv.scrollTo(0, DebugDiv.scrollHeight);
  };
  console.error = console.debug = console.info = console.log;
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  background-color: black;
`;

const PortraitBlock = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 1;
`;

const BlockMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;

  width: 100%;
  height: 100%;
`;

const RotateIcon = styled.div`
  font-size: 30vw;
`;

// eslint-disable-next-line
const Debug = styled(motion.div)`
  pointer-events: none;
  white-space: pre-wrap;
  padding: 40px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  /* max-height: 200px; */
  overflow-x: auto;
`;

export default App;
